import {baseUrl} from'../config';

export const courseController ={
    Url:baseUrl+'/api/course',
} 